import "../scss/page.scss";

import "../scss/privacy-policy.scss";

import "jquery-match-height";

import "./scripts/ebook.js";